var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_320_4541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 13.3333L10.0003 10L6.66699 13.3333",
    stroke: "#0098DA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10V17.5",
    stroke: "#0098DA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9919 15.325C17.8047 14.8819 18.4467 14.1807 18.8168 13.3322C19.1868 12.4836 19.2637 11.536 19.0354 10.6389C18.807 9.74179 18.2864 8.94626 17.5558 8.37787C16.8251 7.80948 15.9259 7.50061 15.0002 7.5H13.9502C13.698 6.52436 13.2278 5.61861 12.5752 4.85082C11.9225 4.08304 11.1042 3.4732 10.182 3.06717C9.25967 2.66113 8.25734 2.46946 7.25031 2.50656C6.24328 2.54367 5.25777 2.80858 4.36786 3.28138C3.47795 3.75419 2.7068 4.42258 2.1124 5.23631C1.51799 6.05005 1.11579 6.98794 0.936028 7.97949C0.756269 8.97104 0.803632 9.99044 1.07456 10.961C1.34548 11.9317 1.83291 12.8282 2.50021 13.5833",
    stroke: "#0098DA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 13.3333L10.0003 10L6.66699 13.3333",
    stroke: "#0098DA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_320_4541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.76c6ad80f5658e72a424e8fba6e1e9f7.svg";
export { ForwardRef as ReactComponent };